import { Button, Icon, Tooltip } from "@mindlercare/ui-web";
import { useState } from "react";
import { styled } from "styled-components";
import { Link } from "components/link";
import { Typography } from "components/typography";

type Props = {
  url: string;
  fileName: string;
  setIsOpen: (isOpen: boolean) => void;
  disabled?: boolean;
};

export const FilePreviewControls = ({
  url,
  fileName,
  setIsOpen,
  disabled = false,
}: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  const isLongFileName = fileName.length > 20;

  const truncateFileName = isLongFileName
    ? `${fileName.slice(0, 15)}...`
    : fileName;

  return (
    <Row
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tooltip content={fileName} disabled={!isLongFileName}>
        <TitleSection>
          <Icon.Attachment color={isHovered ? "white" : "black"} />
          <Link
            to={url}
            variant="body"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
            }}
          >
            <Typography variant="body-small">{truncateFileName}</Typography>
          </Link>
        </TitleSection>
      </Tooltip>

      {!disabled && (
        <Button variant="neutral" onClick={() => setIsOpen(true)}>
          <Icon.Trash color={isHovered ? "white" : "black"} />
        </Button>
      )}
    </Row>
  );
};

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.SPACING.SM};
`;

const Row = styled.div`
  padding: ${({ theme }) => theme.SPACING.XS} ${({ theme }) => theme.SPACING.SM};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.SPACING.SM};
  height: fit-content;
  &:hover {
    background-color: ${({ theme }) => theme.COLORS.ACTION_BLUE};
  }
`;
